export const verifyCodeErrorMessages = {
  VERIFICATION_CODE_INVALID: 'Kod weryfikacyjny jest nieprawidłowy lub stracił ważność. Spróbuj jeszcze raz.',
  VERIFICATION_CODE_MAX_TRY_LIMIT_EXCEEDED: 'Przekroczono maksymalną liczbę prób. Rozpocznij proces ponownie.'
};
